const MicrophoneGrey = ({ color = "#878787" }: { color?: string }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ pointerEvents: "none" }}
    >
      <g clipPath="url(#clip0_2221_1199)">
        <path
          d="M16.4999 9.29778C16.6894 9.29778 16.8711 9.37304 17.005 9.50699C17.139 9.64095 17.2142 9.82263 17.2142 10.0121C17.2144 11.4039 16.7066 12.7479 15.7861 13.7918C14.8656 14.8358 13.5958 15.5079 12.2149 15.6821L12.2142 17.1549H14.3571C14.5465 17.1549 14.7282 17.2302 14.8621 17.3641C14.9961 17.4981 15.0714 17.6798 15.0714 17.8692C15.0714 18.0587 14.9961 18.2403 14.8621 18.3743C14.7282 18.5082 14.5465 18.5835 14.3571 18.5835H8.64279C8.45335 18.5835 8.27167 18.5082 8.13771 18.3743C8.00376 18.2403 7.9285 18.0587 7.9285 17.8692C7.9285 17.6798 8.00376 17.4981 8.13771 17.3641C8.27167 17.2302 8.45335 17.1549 8.64279 17.1549H10.7856V15.6821C9.40465 15.5081 8.13465 14.836 7.21404 13.792C6.29343 12.7481 5.78551 11.404 5.78564 10.0121C5.78564 9.82263 5.8609 9.64095 5.99485 9.50699C6.12881 9.37304 6.31049 9.29778 6.49993 9.29778C6.68937 9.29778 6.87105 9.37304 7.00501 9.50699C7.13896 9.64095 7.21422 9.82263 7.21422 10.0121C7.21422 11.1487 7.66575 12.2388 8.46947 13.0425C9.2732 13.8463 10.3633 14.2978 11.4999 14.2978C12.6366 14.2978 13.7267 13.8463 14.5304 13.0425C15.3341 12.2388 15.7856 11.1487 15.7856 10.0121C15.7856 9.82263 15.8609 9.64095 15.9949 9.50699C16.1288 9.37304 16.3105 9.29778 16.4999 9.29778ZM11.4999 3.5835C12.2577 3.5835 12.9844 3.88452 13.5202 4.42034C14.0561 4.95615 14.3571 5.68288 14.3571 6.44064V10.0121C14.3571 10.7698 14.0561 11.4966 13.5202 12.0324C12.9844 12.5682 12.2577 12.8692 11.4999 12.8692C10.7422 12.8692 10.0154 12.5682 9.47962 12.0324C8.94381 11.4966 8.64279 10.7698 8.64279 10.0121V6.44064C8.64279 5.68288 8.94381 4.95615 9.47962 4.42034C10.0154 3.88452 10.7422 3.5835 11.4999 3.5835Z"
          fill={color}
          style={{ transition: "fill 0.25s" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_2221_1199">
          <rect width="20" height="20" fill="white" transform="translate(1.5 1.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MicrophoneGrey;
